const rootArea = "/tokens";

export const tokenGlob = () => ({
	self: rootArea,
	byType: (type: string) => ({ 						// type is token configuration code (a guid)
		read: `${rootArea}/${type}/read`, 				// read a saved token
		create: `${rootArea}/${type}/create`, 			// save a built token
		build: `${rootArea}/${type}/build`, 			// enter into create token flow, does not include saving
		delete: `${rootArea}/${type}/delete`, 			// delete a saved token
		write: `${rootArea}/${type}/write`, 			// write token to card
		present: `${rootArea}/${type}/present`, 		// display QR or use HCE
		scan: `${rootArea}/${type}/scan`, 				// scan a token from a device or card
		deactivate: `${rootArea}/${type}/deactivate`	// scan a token from a device or card
	})
});